<template>
  <h1>Thanks For Shopping with Us</h1>
</template>

<script>
export default {

}
</script>

<style>

</style>